import { render, staticRenderFns } from "./GeneralInformationSecurityPolicy.vue?vue&type=template&id=3a66d76d"
import script from "./GeneralInformationSecurityPolicy.vue?vue&type=script&lang=js"
export * from "./GeneralInformationSecurityPolicy.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformationSecurityPolicy.vue?vue&type=style&index=0&id=3a66d76d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports